import ApplicationSerializer from './application';

export default ApplicationSerializer.extend({
  serialize() {
    const json = ApplicationSerializer.prototype.serialize.apply(this, arguments);

    (Array.isArray(json.data) ? json.data : [json.data]).forEach(({ attributes, relationships: { location } }) => {
      if (location.data) attributes['location-id'] = location.data.id;
    });

    return json;
  },
});
